import { CXoneAuth, CXoneUser } from '@nice-devone/auth-sdk';
import { CXoneConfiguration } from '@nice-devone/common-sdk';
import { ACDSessionManager, AdminService } from '@nice-devone/core-sdk';
import { AuthToken } from '@nice-devone/common-sdk';
import { getExtendedClient } from '../client-helpers';
import { cxoneSdkState } from '../state';

export async function initializeSdkServices(
  accessToken: string,
  cxoneConfig: CXoneConfiguration,
  authToken: AuthToken,
  userInfo: NonNullable<typeof cxoneSdkState.storedUserInfo>
): Promise<void> {
  const cxoneAuth = CXoneAuth.instance;
  const client = getExtendedClient();

  cxoneAuth.setCXoneConfig(cxoneConfig);
  cxoneAuth.setAuthAndUserData(authToken, true, userInfo);

  const acdSession = ACDSessionManager.instance;
  acdSession.initialize(accessToken, cxoneConfig, userInfo);

  const adminService = AdminService.instance;
  adminService.initialize(accessToken, cxoneConfig, userInfo);

  const cxoneUser = CXoneUser.instance;
  cxoneUser.initAuth(accessToken, cxoneConfig);
  cxoneUser.setUserDetails(authToken, userInfo);

  await client.initAuthDependentModules();
}

export async function updateSdkAuthToken(accessToken: string): Promise<void> {
  const cxoneAuth = CXoneAuth.instance;
  const authToken = new AuthToken();
  authToken.parseData({
    access_token: accessToken,
    token_type: 'Bearer',
    expires_in: 3600,
    refresh_token: '',
    issued_token_type: '',
    id_token: '',
  });
  cxoneAuth.setAuthToken(authToken);
}
